import { getBrowser } from "./browser";
export function showAiEntry(showtype, contentType, docAuth, isHomePage, isLogin, isMettingDoc, isEditorPreview) {
    /*不显示：
                  移动端 &&
                  三方接入知识库 &&
                  非轻文档类型 &&
                  没有读取权限 &&
                  非编辑器页面（历史记录、设置、回收站除外）&&
                  会议纪要
                  模板库预览
          */
    let isMobile = getBrowser().isMobile;
    let isInThird = showtype === "sdk" || showtype === "kp";
    let isDocOrExcel = (
        contentType === 'DOCUMENT' ||
        contentType === 'EXCEL' ||
        contentType === 'WORD' ||
        contentType === 'PPT' ||
        contentType === 'PDF'
    );
    let isHasAuth =
        docAuth === "READ" ||
            docAuth === "READ_DOWNLOAD" ||
            docAuth === "WRITE" ||
            docAuth === "ALL"
            ? true
            : false;

    if (
        isMobile ||
        isInThird ||
        !isDocOrExcel ||
        !isHasAuth ||
        !isHomePage ||
        !isLogin ||
        isMettingDoc ||
        isEditorPreview
    ) {
        return false;
    }
    return true;
}